import { render, staticRenderFns } from "./m-block-desc-card.vue?vue&type=template&id=3cd16724&scoped=true&"
import script from "./m-block-desc-card.vue?vue&type=script&lang=ts&"
export * from "./m-block-desc-card.vue?vue&type=script&lang=ts&"
import style0 from "./m-block-desc-card.vue?vue&type=style&index=0&id=3cd16724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd16724",
  null
  
)

export default component.exports